import React, { useEffect, useState } from "react"
import CramLayout from "./CramLayout";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
import { HomeOutlined, ContactsOutlined, FileTextOutlined, AppstoreOutlined, LaptopOutlined, UserOutlined } from '@ant-design/icons';
import axios from "axios";
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import { usePermission } from './permission/controllers/usePermission'
const { Header, Content, Sider } = Layout;
// const useAuth = () => {
//     //get item from localstorage
//     //後端api傳回身份管理
//     let user

//     const _user = localStorage.getItem("user")

//     if (_user) {
//         user = JSON.parse(_user)
//     }
//     if (user) {
//         return {
//             auth: true,
//             role: user.role,
//         }
//     } else {
//         return {
//             auth: false,
//             role: null,
//         }
//     }
// }

//protected Route state

const Sidebar = (props) => {
    // const { auth, role, path } = useAuth()
    const [nav, setNav] = useState([]);
    const [li, setLi] = useState([]);
    const [identity, setIdentity] = useState([])
    const navigate = useNavigate();

    function getItem(label, key, icon, children, disabled, type) {
        return {
            key,
            icon,
            children,
            label,
            disabled,
            type
        };
    }
    const get_identity = () => {
        axios
            .get(`/cramSchool/api/permission`,)
            .then((response) => {
                setIdentity(response.data)
            })
    }
    const getSideItem = (item, accessUrl) => {
        if (item?.children) {
            return {
                ...item,
                children: item?.children.map((value) => {
                    return getSideItem(value, accessUrl)
                })
            }
        }
        else {
            if (accessUrl.includes(item?.key)) {
                return item
            }
            else {
                return
            }
        }
    }
    const setSideBar = (accessPrmissions) => {
        
        let accessUrl = accessPrmissions.map((val) => {
            return val?.permission_url
        })
        // let allPermissions = [
        //     getItem(<a href="/cramSchool" target='_blank'>Mercy形象網站</a>, "/cramSchool/admin/manuals", <HomeOutlined />),
        //     getItem('即時總覽', "/cramSchool/admin", <ContactsOutlined />),
        //     getItem('行政管理設定', 'admin', <ContactsOutlined />, [
        //         getItem('員工基本資料管理 ', '/cramSchool/admin/TeacherList'),
        //         // getItem('行政人員資料管理', '/cramSchool/admin/AdministrationList'),
        //         getItem('環境基本資料管理', '/cramSchool/admin/EnviornmentList'),
        //         getItem('權限設定管理', '/cramSchool/admin/PermissionsList/All'),
        //         getItem('媒體資訊管理', '/cramSchool/admin/Media/News'),
        //     ]),
        //     getItem('開課前', 'before', <ContactsOutlined />, [
        //         getItem('基本資料維護', 'basic', null, [
        //             getItem('學生基本資料管理', '/cramSchool/admin/StudentList'),
        //             getItem('課程基本資料管理', '/cramSchool/admin/ClassList'),
        //         ]),
        //         getItem('形象推廣管理模組', "/cramSchool/admin/AdminNews"),
        //         getItem('線上聊天平台', "/cramSchool/admin/ChatRoom"),
        //         getItem('學費系統管理', "/cramSchool/admin/AdminLessonTuitionOverview"),

        //     ]),
        //     getItem('開課中', 'starting', <ContactsOutlined />, [
        //         getItem('打卡管理模組', '/cramSchool/admin/PunchManagement'),
        //     ]),
        //     getItem(<a target="_blank" href="https://drive.google.com/drive/folders/12C8A4KBek6NxXjeysMya0PKj5ydYGfs5">系統操作手冊</a>, '/cramSchool/admin/manuals', <FileTextOutlined />),
        //     getItem('系統意見回饋表單', "/cramSchool/admin/Form", <FileTextOutlined />),
        //     getItem(<a target="_blank" href="https://drive.google.com/drive/folders/138N-hbSFVBDTLKS4ZleE3QWo3IXZda_8">Mercy協助事項</a>, "/cramSchool/admin/manuals", <FileTextOutlined />),
        // ]
        let allPermissions = [
            // getItem(<a href="/iTeach" target='_blank'>Mercy形象網站</a>, "/iTeach/admin/manuals", <HomeOutlined />, []),
            // getItem('即時總覽', "/iTeach/admin", <ContactsOutlined />, []),
            
            getItem('基本資料管理', 'admin', <ContactsOutlined />, [
                getItem('教師、行政基本資料管理', '/cramSchool/admin/TeacherList'),
                // getItem('行政人員資料管理', '/cramSchool/admin/AdministrationList'),
                // getItem('助教基本資料管理', '/cramSchool/admin/TeacherAssisstantList'),
                getItem('學生基本資料管理', '/cramSchool/admin/StudentList'),
                getItem('課程基本資料管理', '/cramSchool/admin/LessonList'),
                getItem('權限設定管理', '/cramSchool/admin/PermissionsList/All'),
                // getItem('媒體資訊管理', '/iTeach/admin/Media/News'),
            ]),
            // getItem('課程管理 ', 'before', <ContactsOutlined />, [
            //     getItem('課程基本資料管理', '/cramSchool/admin/LessonList'),
            //     getItem('課程分類基本資料管理', '/cramSchool/admin/LessonCategoryList'),
            //     getItem('授課時間管理', '/cramSchool/admin/ClassList'),
            //     getItem('權限設定管理', '/cramSchool/admin/PermissionsList/All'),
            // ]),
            // getItem('開課前dfghj', 'before', <ContactsOutlined />, [
            //     getItem('基本資料維護', 'basic', null, [
            //         getItem('學生基本資料管理', '/iTeach/admin/StudentList'),
            //         getItem('課程基本資料管理', '/iTeach/admin/ClassList'),
            //     ]),
            //     getItem('形象推廣管理模組', "/iTeach/admin/AdminNews"),
            //     getItem('線上聊天平台', "/iTeach/admin/ChatRoom"),
            //     getItem('學費系統管理', "/iTeach/admin/AdminLessonTuitionOverview"),

            // ]),
            // getItem('開課中', 'starting', <ContactsOutlined />, [
            //     getItem('打卡管理模組', '/iTeach/admin/PunchManagement'),
            // ]),
            // getItem(<a target="_blank" href="https://drive.google.com/drive/folders/12C8A4KBek6NxXjeysMya0PKj5ydYGfs5">系統操作手冊</a>, '/iTeach/admin/manuals', <FileTextOutlined />),
            // getItem('系統意見回饋表單', "/iTeach/admin/Form", <FileTextOutlined />),
            // getItem(<a target="_blank" href="https://drive.google.com/drive/folders/138N-hbSFVBDTLKS4ZleE3QWo3IXZda_8">Mercy協助事項</a>, "/iTeach/admin/manuals", <FileTextOutlined />),
        ]
        let test = []
        allPermissions.forEach((value) => {
            let temp = getSideItem(value, accessUrl || [])
            if (temp) {
                test.push(temp)
            }
        })
        setLi(test)
    }
    const {
        getPermissionSelfDatas,
        permissionsSelfDatas
    } = usePermission({
        onBefore:()=>{},
        onFinish:()=>{}
    })
    useEffect(() => {
        get_identity();
        getPermissionSelfDatas({})

        // setSideBar()
    }, [])
    useEffect(()=>{
        let permissionsSelfDatasFirst = permissionsSelfDatas.find((ele)=>true)
        let userPermissions = permissionsSelfDatasFirst?.role_permission ||[]
        setSideBar(userPermissions)
    },[permissionsSelfDatas])
    useEffect(() => {
        if (props.topic == 'admin') {
            setNav(
                []
            )

            // setLi([
            //     getItem(<a href="/cramSchool" target='_blank'>Mercy形象網站</a>, "/cramSchool/admin/manuals", <HomeOutlined />),
            //     getItem('即時總覽', "/cramSchool/admin", <ContactsOutlined />),
            //     getItem('行政管理設定', 'admin', <ContactsOutlined />, [
            //         getItem('員工基本資料管理 ', '/cramSchool/admin/TeacherList'),
            //         // getItem('行政人員資料管理', '/cramSchool/admin/AdministrationList'),
            //         getItem('環境基本資料管理', '/cramSchool/admin/EnviornmentList'),
            //         getItem('權限設定管理', '/cramSchool/admin/PermissionsList/All'),
            //         getItem('媒體資訊管理', '/cramSchool/admin/Media/News'),
            //     ]),
            //     // // getItem(學員清冊 "/cramSchool/exam/StudentList"),
            //     // identity.map((value, index) => {
            //     //     console.log(value.name)
            //     //     getItem({value.name} 'sub2', <AppstoreOutlined />, [
            //     //         // value.permission_list.map((data_tmp,data_index) =>{
            //     //         //     console.log(data_tmp.permission_name)
            //     //         getItem('學生基本資料管理', "/cramSchool/admin/StudentList")
            //     //         // }) 
            //     //     ])
            //     // }),
            //     getItem('開課前', 'before', <ContactsOutlined />, [
            //         getItem('基本資料維護', 'basic', null, [
            //             getItem('學生基本資料管理', '/cramSchool/admin/StudentList'),
            //             getItem('課程基本資料管理', '/cramSchool/admin/ClassList'),
            //             // getItem('課程基本資料管理', '/cramSchool/admin/LessonList'),
            //             // getItem(年級基本資料管理 '/cramSchool/admin/GradeList'),
            //             // getItem('班級基本資料管理', '/cramSchool/admin/ClassList'),
            //         ]),
            //         getItem('形象推廣管理模組', "/cramSchool/admin/AdminNews"),
            //         // getItem('課程編排管理模組', "/cramSchool/admin/MakeNews", null),
            //         // getItem('授課管理模組', "/cramSchool/admin/AddStudentList", null),
            //         // getItem('學費管理模組', "/cramSchool/admin/RFIDRollCall", null),
            //         // getItem('客戶品質管理模組', "/cramSchool/admin/RFIDRollCall", null),
            //         // getItem('填表預約', "/cramSchool/admin/Appointment", null),
            //         getItem('線上聊天平台', "/cramSchool/admin/ChatRoom"),
            //         getItem('學費系統管理', "/cramSchool/admin/AdminLessonTuitionOverview"),

            //     ]),
            //     // getItem('開課中', 'now', <ContactsOutlined />, [
            //     //     getItem('課程大網簡介 ', "/cramSchool/admin/CourseOutline"),
            //     //     getItem('課程清單', "/cramSchool/admin/CourseList"),
            //     //     getItem('教師調/補課管理 ', "/cramSchool/admin/TeacherCourseManage/All"),
            //     //     // getItem('請假管理模組 ', "/", null),
            //     // ]),
            //     getItem('開課中', 'starting', <ContactsOutlined />, [
            //         getItem('打卡管理模組', '/cramSchool/admin/PunchManagement'),
            //     ]),
            //     getItem(<a target="_blank" href="https://drive.google.com/drive/folders/12C8A4KBek6NxXjeysMya0PKj5ydYGfs5">系統操作手冊</a>, '/cramSchool/admin/manuals', <FileTextOutlined />),
            //     getItem('系統意見回饋表單', "/cramSchool/admin/Form", <FileTextOutlined />),
            //     getItem(<a target="_blank" href="https://drive.google.com/drive/folders/138N-hbSFVBDTLKS4ZleE3QWo3IXZda_8">Mercy協助事項</a>, "/cramSchool/admin/manuals", <FileTextOutlined />),




            //     // getItem(<span style={{ fontSize: '30px' }}>登出 '/', <UserOutlined />),
            // ])

        }
        // else if (props.topic == 'admin') {
        //     setNav(
        //         []
        //     )
        //     setLi([
        //         getItem(<span style={{ fontFamily: 'BerkshireSwash_400Regular', fontSize: '36px', fontweight: 400, letterSpacing: '0px', lineheight: '0px', color: 'rgba(0, 0, 0, 1)' }}>MERCY</span>),
        //         getItem(及時總覽"/" ),
        //         getItem(學員清冊"/"  ),
        //         getItem(形象網站批次管理 "/cramSchool/admin/Manage", <BorderOutlined />),
        //         getItem(通訊錄"/" ,  <BorderOutlined />),
        //         getItem(學費管理 "/",  <BorderOutlined />),

        //         // getItem(<span style={{fontSize:'30px'}}>登出 '/', <UserOutlined />),
        //     ])
        // }
    }, [identity]
    )

    //if the role required is there or not
    return (
        // auth ?
        //     (

        (
            <CramLayout
                nav={nav}
                li={li}
                setLi={setLi}            >
                <Outlet />
            </CramLayout>






            //  <Layout>
            //     <Layout>
            //         <Sider
            //         >
            //             <Menu
            //                 mode="inline"
            //                 defaultSelectedKeys={['1']}
            //                 defaultOpenKeys={['sub1']}
            //                 style={{
            //                     height: '100%',
            //                     borderRight: 0,
            //                 }}
            //                 items={items2}
            //                 onClick={({ key }) => {
            //                     navigate(key)
            //                 }}
            //             />
            //         </Sider>

            //         <Content>
            //             <Outlet />
            //         </Content>
            //     </Layout>
            // </Layout> 



        )

        // : (
        //      <Navigate to="/" />
        //  )
    )
}

export default Sidebar;



// import React, { useEffect, useState } from "react"
// import CramLayout from "./CramLayout";
// import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
// import { HomeOutlined, ContactsOutlined, FileTextOutlined, AppstoreOutlined, LaptopOutlined, UserOutlined } from '@ant-design/icons';
// import axios from "axios";
// import { Breadcrumb, Layout, Menu, theme } from 'antd';
// import { usePermission } from './permission/controllers/usePermission'
// const { Header, Content, Sider } = Layout;
// // const useAuth = () => {
// //     //get item from localstorage
// //     //後端api傳回身份管理
// //     let user

// //     const _user = localStorage.getItem("user")

// //     if (_user) {
// //         user = JSON.parse(_user)
// //     }
// //     if (user) {
// //         return {
// //             auth: true,
// //             role: user.role,
// //         }
// //     } else {
// //         return {
// //             auth: false,
// //             role: null,
// //         }
// //     }
// // }

// //protected Route state

// const Sidebar = (props) => {
//     // const { auth, role, path } = useAuth()
//     const [nav, setNav] = useState([]);
//     const [li, setLi] = useState([]);
//     const [identity, setIdentity] = useState([])
//     const navigate = useNavigate();

//     function getItem(label, key, icon, children, disabled, type) {
//         return {
//             key,
//             icon,
//             children,
//             label,
//             disabled,
//             type
//         };
//     }
//     const get_identity = () => {
//         axios
//             .get(`/cramSchool/api/permission`,)
//             .then((response) => {
//                 setIdentity(response.data)
//             })
//     }
//     const getSideItem = (item, accessUrl) => {
//         if (item?.children) {
//             return {
//                 ...item,
//                 children: item?.children.map((value) => {
//                     return getSideItem(value, accessUrl)
//                 })
//             }
//         }
//         else {
//             if (accessUrl.includes(item?.key)) {
//                 return item
//             }
//             else {
//                 return
//             }
//         }
//     }
//     const setSideBar = (accessPrmissions) => {
        
//         let accessUrl = accessPrmissions.map((val) => {
//             return val?.permission_url
//         })
//         let allPermissions = [
//             getItem(<a href="/cramSchool" target='_blank'>Mercy形象網站</a>, "/cramSchool/admin/manuals", <HomeOutlined />),
//             getItem('即時總覽', "/cramSchool/admin", <ContactsOutlined />),
//             getItem('行政管理設定', 'admin', <ContactsOutlined />, [
//                 getItem('員工基本資料管理 ', '/cramSchool/admin/TeacherList'),
//                 // getItem('行政人員資料管理', '/cramSchool/admin/AdministrationList'),
//                 getItem('環境基本資料管理', '/cramSchool/admin/EnviornmentList'),
//                 getItem('權限設定管理', '/cramSchool/admin/PermissionsList/All'),
//                 getItem('媒體資訊管理', '/cramSchool/admin/Media/News'),
//             ]),
//             getItem('開課前', 'before', <ContactsOutlined />, [
//                 getItem('基本資料維護', 'basic', null, [
//                     getItem('學生基本資料管理', '/cramSchool/admin/StudentList'),
//                     getItem('課程基本資料管理', '/cramSchool/admin/ClassList'),
//                 ]),
//                 getItem('形象推廣管理模組', "/cramSchool/admin/AdminNews"),
//                 getItem('線上聊天平台', "/cramSchool/admin/ChatRoom"),
//                 getItem('學費系統管理', "/cramSchool/admin/AdminLessonTuitionOverview"),

//             ]),
//             getItem('開課中', 'starting', <ContactsOutlined />, [
//                 getItem('打卡管理模組', '/cramSchool/admin/PunchManagement'),
//             ]),
//             getItem(<a target="_blank" href="https://drive.google.com/drive/folders/12C8A4KBek6NxXjeysMya0PKj5ydYGfs5">系統操作手冊</a>, '/cramSchool/admin/manuals', <FileTextOutlined />),
//             getItem('系統意見回饋表單', "/cramSchool/admin/Form", <FileTextOutlined />),
//             getItem(<a target="_blank" href="https://drive.google.com/drive/folders/138N-hbSFVBDTLKS4ZleE3QWo3IXZda_8">Mercy協助事項</a>, "/cramSchool/admin/manuals", <FileTextOutlined />),
//         ]
//         let test = []
//         allPermissions.forEach((value) => {
//             let temp = getSideItem(value, accessUrl || [])
//             if (temp) {
//                 test.push(temp)
//             }
//         })
//         setLi(test)
//     }
//     const {
//         getPermissionSelfDatas,
//         permissionsSelfDatas
//     } = usePermission({
//         onBefore:()=>{},
//         onFinish:()=>{}
//     })
//     useEffect(() => {
//         get_identity();
//         getPermissionSelfDatas({})

//         // setSideBar()
//     }, [])
//     useEffect(()=>{
//         let permissionsSelfDatasFirst = permissionsSelfDatas.find((ele)=>true)
//         let userPermissions = permissionsSelfDatasFirst?.role_permission ||[]
//         setSideBar(userPermissions)
//     },[permissionsSelfDatas])
//     useEffect(() => {
//         if (props.topic == 'admin') {
//             setNav(
//                 []
//             )

//             // setLi([
//             //     getItem(<a href="/cramSchool" target='_blank'>Mercy形象網站</a>, "/cramSchool/admin/manuals", <HomeOutlined />),
//             //     getItem('即時總覽', "/cramSchool/admin", <ContactsOutlined />),
//             //     getItem('行政管理設定', 'admin', <ContactsOutlined />, [
//             //         getItem('員工基本資料管理 ', '/cramSchool/admin/TeacherList'),
//             //         // getItem('行政人員資料管理', '/cramSchool/admin/AdministrationList'),
//             //         getItem('環境基本資料管理', '/cramSchool/admin/EnviornmentList'),
//             //         getItem('權限設定管理', '/cramSchool/admin/PermissionsList/All'),
//             //         getItem('媒體資訊管理', '/cramSchool/admin/Media/News'),
//             //     ]),
//             //     // // getItem(學員清冊 "/cramSchool/exam/StudentList"),
//             //     // identity.map((value, index) => {
//             //     //     console.log(value.name)
//             //     //     getItem({value.name} 'sub2', <AppstoreOutlined />, [
//             //     //         // value.permission_list.map((data_tmp,data_index) =>{
//             //     //         //     console.log(data_tmp.permission_name)
//             //     //         getItem('學生基本資料管理', "/cramSchool/admin/StudentList")
//             //     //         // }) 
//             //     //     ])
//             //     // }),
//             //     getItem('開課前', 'before', <ContactsOutlined />, [
//             //         getItem('基本資料維護', 'basic', null, [
//             //             getItem('學生基本資料管理', '/cramSchool/admin/StudentList'),
//             //             getItem('課程基本資料管理', '/cramSchool/admin/ClassList'),
//             //             // getItem('課程基本資料管理', '/cramSchool/admin/LessonList'),
//             //             // getItem(年級基本資料管理 '/cramSchool/admin/GradeList'),
//             //             // getItem('班級基本資料管理', '/cramSchool/admin/ClassList'),
//             //         ]),
//             //         getItem('形象推廣管理模組', "/cramSchool/admin/AdminNews"),
//             //         // getItem('課程編排管理模組', "/cramSchool/admin/MakeNews", null),
//             //         // getItem('授課管理模組', "/cramSchool/admin/AddStudentList", null),
//             //         // getItem('學費管理模組', "/cramSchool/admin/RFIDRollCall", null),
//             //         // getItem('客戶品質管理模組', "/cramSchool/admin/RFIDRollCall", null),
//             //         // getItem('填表預約', "/cramSchool/admin/Appointment", null),
//             //         getItem('線上聊天平台', "/cramSchool/admin/ChatRoom"),
//             //         getItem('學費系統管理', "/cramSchool/admin/AdminLessonTuitionOverview"),

//             //     ]),
//             //     // getItem('開課中', 'now', <ContactsOutlined />, [
//             //     //     getItem('課程大網簡介 ', "/cramSchool/admin/CourseOutline"),
//             //     //     getItem('課程清單', "/cramSchool/admin/CourseList"),
//             //     //     getItem('教師調/補課管理 ', "/cramSchool/admin/TeacherCourseManage/All"),
//             //     //     // getItem('請假管理模組 ', "/", null),
//             //     // ]),
//             //     getItem('開課中', 'starting', <ContactsOutlined />, [
//             //         getItem('打卡管理模組', '/cramSchool/admin/PunchManagement'),
//             //     ]),
//             //     getItem(<a target="_blank" href="https://drive.google.com/drive/folders/12C8A4KBek6NxXjeysMya0PKj5ydYGfs5">系統操作手冊</a>, '/cramSchool/admin/manuals', <FileTextOutlined />),
//             //     getItem('系統意見回饋表單', "/cramSchool/admin/Form", <FileTextOutlined />),
//             //     getItem(<a target="_blank" href="https://drive.google.com/drive/folders/138N-hbSFVBDTLKS4ZleE3QWo3IXZda_8">Mercy協助事項</a>, "/cramSchool/admin/manuals", <FileTextOutlined />),




//             //     // getItem(<span style={{ fontSize: '30px' }}>登出 '/', <UserOutlined />),
//             // ])

//         }
//         // else if (props.topic == 'admin') {
//         //     setNav(
//         //         []
//         //     )
//         //     setLi([
//         //         getItem(<span style={{ fontFamily: 'BerkshireSwash_400Regular', fontSize: '36px', fontweight: 400, letterSpacing: '0px', lineheight: '0px', color: 'rgba(0, 0, 0, 1)' }}>MERCY</span>),
//         //         getItem(及時總覽"/" ),
//         //         getItem(學員清冊"/"  ),
//         //         getItem(形象網站批次管理 "/cramSchool/admin/Manage", <BorderOutlined />),
//         //         getItem(通訊錄"/" ,  <BorderOutlined />),
//         //         getItem(學費管理 "/",  <BorderOutlined />),

//         //         // getItem(<span style={{fontSize:'30px'}}>登出 '/', <UserOutlined />),
//         //     ])
//         // }
//     }, [identity]
//     )

//     //if the role required is there or not
//     return (
//         // auth ?
//         //     (

//         (
//             <CramLayout
//                 nav={nav}
//                 li={li}
//                 setLi={setLi}            >
//                 <Outlet />
//             </CramLayout>






//             //  <Layout>
//             //     <Layout>
//             //         <Sider
//             //         >
//             //             <Menu
//             //                 mode="inline"
//             //                 defaultSelectedKeys={['1']}
//             //                 defaultOpenKeys={['sub1']}
//             //                 style={{
//             //                     height: '100%',
//             //                     borderRight: 0,
//             //                 }}
//             //                 items={items2}
//             //                 onClick={({ key }) => {
//             //                     navigate(key)
//             //                 }}
//             //             />
//             //         </Sider>

//             //         <Content>
//             //             <Outlet />
//             //         </Content>
//             //     </Layout>
//             // </Layout> 



//         )

//         // : (
//         //      <Navigate to="/" />
//         //  )
//     )
// }

// export default Sidebar;

